import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import ReactGA from "react-ga4";
import { Card, CardContent, Typography } from "@mui/material";
import SeoHelmet from "../components/SeoHelmet";
import birthdayReminderIcon from "../static/birthday_reminder.png";
import "./ToolDetail.css";

const BirthdayReminder = () => {
    const trackPlayStoreClick = () => {
        ReactGA.event({
            category: "BirthdayReminder",
            action: "User pressed Play Store",
        });
    };

    return (
        <div className="Container">
            <SeoHelmet
                title="InstanceOf | Birthday Reminder"
                description="Keep friends’ and family members’ birthdays in a list and customize when Birthday Reminder notifies you."
            />
            <Navbar />

            <main className="Centered-Content ToolDetail-content">
                <section className="ToolDetail-hero">
                    <img
                        className="ToolDetail-icon"
                        src={birthdayReminderIcon}
                        alt="Birthday Reminder app icon"
                    />
                    <div className="ToolDetail-hero-copy">
                        <Typography
                            component="h1"
                            variant="h3"
                            className="ToolDetail-title"
                        >
                            Birthday Reminder
                        </Typography>
                        <Typography
                            component="p"
                            variant="h6"
                            className="ToolDetail-lead"
                        >
                            Keep birthdays from slipping your mind.
                        </Typography>
                        <Typography
                            component="p"
                            variant="body1"
                            className="ToolDetail-description"
                        >
                            Add friends’ and family members’ birthdays to your
                            list, then customize when reminders arrive and
                            whose birthdays trigger them.
                        </Typography>
                        <div className="ToolDetail-actions">
                            <a
                                className="ToolDetail-play-badge"
                                href="https://play.google.com/store/apps/details?id=com.nunoreis.birthdayreminder&utm_source=instanceof"
                                onClick={trackPlayStoreClick}
                                aria-label="Get Birthday Reminder on Google Play"
                            >
                                <img
                                    src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
                                    alt="Get it on Google Play"
                                />
                            </a>
                        </div>
                    </div>
                </section>

                <section className="ToolDetail-section">
                    <Typography
                        component="h2"
                        variant="h5"
                        className="ToolDetail-section-title"
                    >
                        Keep birthdays and reminders organized
                    </Typography>
                    <div className="ToolDetail-feature-grid">
                        <Card className="ToolDetail-feature">
                            <CardContent>
                                <Typography
                                    component="h3"
                                    variant="h6"
                                    className="ToolDetail-feature-title"
                                >
                                    Your birthday list
                                </Typography>
                                <Typography
                                    component="p"
                                    variant="body2"
                                    className="ToolDetail-feature-copy"
                                >
                                    Add the names and birthdays of friends
                                    and family members you want to remember.
                                </Typography>
                            </CardContent>
                        </Card>
                        <Card className="ToolDetail-feature">
                            <CardContent>
                                <Typography
                                    component="h3"
                                    variant="h6"
                                    className="ToolDetail-feature-title"
                                >
                                    Reminders your way
                                </Typography>
                                <Typography
                                    component="p"
                                    variant="body2"
                                    className="ToolDetail-feature-copy"
                                >
                                    Choose when notifications arrive,
                                    whether to receive push notifications,
                                    and whether reminders cover your
                                    birthday or everyone on your list.
                                </Typography>
                            </CardContent>
                        </Card>
                    </div>
                </section>

                <section className="ToolDetail-note">
                    <Typography
                        component="h2"
                        variant="h6"
                        className="ToolDetail-note-title"
                    >
                        Sign-in and privacy
                    </Typography>
                    <Typography
                        component="p"
                        variant="body2"
                        className="ToolDetail-note-copy"
                    >
                        The app requires Facebook sign-in and uses your name
                        and email to create your account. See the{" "}
                        <a href="/tech-corner/birthday-reminder/privacy">
                            Birthday Reminder privacy policy
                        </a>{" "}
                        for details.
                    </Typography>
                </section>
            </main>

            <Footer />
        </div>
    );
};

export default BirthdayReminder;
